/* grasetiketten.de: Etiketten-Finder, Formsymbole und Kennzahlen aus dem Produktindex (benoetigt ge-config.js) */
(function () {
  'use strict';
  if (window.__geFinder) return;
  window.__geFinder = true;

  var PAGE = 24;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function ready(fn) {
    if (window.GE) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
    } else {
      document.addEventListener('ge:ready', fn);
    }
  }

  function fmtNum(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function parseNum(s) {
    var v = parseFloat(String(s || '').replace(',', '.').replace(/[^0-9.]/g, ''));
    return isFinite(v) && v > 0 ? v : 0;
  }

  /* ---------- Finder ---------- */
  function Finder(el, items, GE) {
    this.el = el;
    this.GE = GE;
    this.items = items;
    this.form = el.querySelector('[data-ge-finder-form]');
    this.list = el.querySelector('[data-ge-results]');
    this.countEl = el.querySelector('[data-ge-count]');
    this.moreBtn = el.querySelector('[data-ge-more]');
    this.ehLink = el.querySelector('[data-ge-eh]');
    this.ehBase = this.ehLink ? this.ehLink.getAttribute('data-ge-eh') : '';
    this.shown = PAGE;
    this.timer = null;
    var more = el.querySelector('[data-ge-morefilters]');
    if (more && window.matchMedia && window.matchMedia('(min-width: 990px)').matches) more.open = true;
    this.fromUrl();
    var st0 = this.state();
    if (more && (st0.m.length || st0.lager || st0.k10 || st0.abl || st0.sort !== 'fit')) more.open = true;
    this.bind();
    this.render(false);
    el.classList.add('is-ready');
    /* Gewaehlte Form in der waagerecht scrollbaren Leiste sichtbar machen */
    var chk = this.form.querySelector('.ge-chips--scroll input:checked');
    var row = chk && chk.closest('.ge-chips--scroll'), chip = chk && chk.closest('.ge-chip');
    if (row && chip && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, chip.offsetLeft - row.offsetLeft - row.clientWidth / 2 + chip.offsetWidth / 2);
  }

  Finder.prototype.fromUrl = function () {
    var q = new URLSearchParams(window.location.search), f = this.form;
    var form = q.get('form') || '';
    var r = f.querySelector('input[name="form"][value="' + (window.CSS && CSS.escape ? CSS.escape(form) : form) + '"]');
    if (r) r.checked = true;
    if (q.get('w')) f.elements.w.value = q.get('w');
    if (q.get('h')) f.elements.h.value = q.get('h');
    if (q.get('tol') && f.elements.tol) f.elements.tol.value = q.get('tol');
    var ms = (q.get('m') || '').split(',');
    each(f.querySelectorAll('input[name="m"]'), function (i) { i.checked = ms.indexOf(i.value) >= 0; });
    ['lager', 'k10', 'abl'].forEach(function (k) { if (f.elements[k]) f.elements[k].checked = q.get(k) === '1'; });
    if (q.get('sort') && f.elements.sort) f.elements.sort.value = q.get('sort');
  };

  Finder.prototype.state = function () {
    var f = this.form;
    var r = f.querySelector('input[name="form"]:checked');
    var st = {
      form: r ? r.value : '',
      w: parseNum(f.elements.w.value),
      h: parseNum(f.elements.h.value),
      tol: parseFloat(f.elements.tol ? f.elements.tol.value : 5) || 5,
      m: [],
      lager: !!(f.elements.lager && f.elements.lager.checked),
      k10: !!(f.elements.k10 && f.elements.k10.checked),
      abl: !!(f.elements.abl && f.elements.abl.checked),
      sort: f.elements.sort ? f.elements.sort.value : 'fit'
    };
    if (st.form === 'rund') st.h = 0;
    each(f.querySelectorAll('input[name="m"]:checked'), function (i) { st.m.push(i.value); });
    return st;
  };

  Finder.prototype.toUrl = function (st) {
    var q = new URLSearchParams();
    if (st.form) q.set('form', st.form);
    if (st.w) q.set('w', fmtNum(st.w));
    if (st.h) q.set('h', fmtNum(st.h));
    if (st.w && st.tol !== 5) q.set('tol', String(st.tol));
    if (st.m.length) q.set('m', st.m.join(','));
    if (st.lager) q.set('lager', '1');
    if (st.k10) q.set('k10', '1');
    if (st.abl) q.set('abl', '1');
    if (st.sort && st.sort !== 'fit') q.set('sort', st.sort);
    var s = q.toString();
    try { history.replaceState(null, '', window.location.pathname + (s ? '?' + s : '')); } catch (e) { /* egal */ }
  };

  Finder.prototype.fit = function (i, st) {
    if (!st.w) return null;
    var z = this.GE.parseSize(i.s);
    if (!z) return { d: Infinity };
    var d;
    if (st.h) {
      d = Math.min(
        Math.max(Math.abs(z.w - st.w), Math.abs(z.h - st.h)),
        Math.max(Math.abs(z.h - st.w), Math.abs(z.w - st.h))
      );
    } else {
      d = Math.min(Math.abs(z.w - st.w), Math.abs(z.h - st.w));
    }
    return { d: Math.round(d * 10) / 10 };
  };

  /* skip: 'form' oder 'm', um Zaehler fuer diese Auswahl zu berechnen */
  Finder.prototype.pass = function (i, st, skip, ignoreSize) {
    if (skip !== 'form' && st.form && i.f !== st.form) return false;
    if (skip !== 'm' && st.m.length && st.m.indexOf(i.m) < 0) return false;
    if (st.lager && i.lz !== '1-3') return false;
    if (st.k10 && !i.p10) return false;
    if (st.abl && String(i.k || '').indexOf('A') < 0) return false;
    if (!ignoreSize && st.w) {
      var ft = this.fit(i, st);
      if (!ft || ft.d > st.tol) return false;
    }
    return true;
  };

  Finder.prototype.sorter = function (st) {
    var GE = this.GE, self = this, mode = st.sort;
    /* Ohne Groesse: Lagerware zuerst, dann nach Groesse */
    if (mode === 'fit' && !st.w) mode = 'std';
    return function (a, b) {
      if (mode === 'std') {
        var sa = a.so ? 1 : 0, sb = b.so ? 1 : 0;
        if (sa !== sb) return sa - sb;
      } else if (mode === 'fit') {
        var d = self.fit(a, st).d - self.fit(b, st).d;
        if (d) return d;
      } else if (mode === 'n') {
        if (b.n !== a.n) return b.n - a.n;
      } else if (mode === 'price') {
        if (a.pu !== b.pu) return a.pu - b.pu;
      }
      return GE.area(a.s) - GE.area(b.s) || a.n - b.n || (a.m < b.m ? -1 : a.m > b.m ? 1 : 0);
    };
  };

  Finder.prototype.counts = function (st) {
    var self = this, fc = { '': 0 }, mc = {};
    this.items.forEach(function (i) {
      if (self.pass(i, st, 'form')) { fc[''] += 1; fc[i.f] = (fc[i.f] || 0) + 1; }
      if (self.pass(i, st, 'm')) mc[i.m] = (mc[i.m] || 0) + 1;
    });
    each(this.form.querySelectorAll('input[name="form"]'), function (inp) {
      var n = fc[inp.value] || 0, lab = inp.closest('.ge-chip'), out = lab && lab.querySelector('.ge-chip__n');
      if (out) out.textContent = n;
      if (lab) lab.classList.toggle('is-empty', !n);
    });
    each(this.form.querySelectorAll('input[name="m"]'), function (inp) {
      var n = mc[inp.value] || 0, lab = inp.closest('.ge-chip'), out = lab && lab.querySelector('.ge-chip__n');
      if (out) out.textContent = n;
      if (lab) lab.classList.toggle('is-empty', !n);
    });
  };

  Finder.prototype.card = function (i, idx, st, near) {
    var GE = this.GE, esc = GE.esc;
    var ft = this.fit(i, st);
    var fitTxt = '';
    if (ft && isFinite(ft.d)) {
      fitTxt = ft.d <= 0.5
        ? '<span class="ge-card__fit is-exact">Passt genau</span>'
        : '<span class="ge-card__fit' + (near ? ' is-near' : '') + '">Abweichung bis ' + fmtNum(ft.d) + ' mm</span>';
    }
    var lz = i.so
      ? 'Sonderanfertigung' + (i.lz ? ', ca. ' + esc(i.lz) + ' Werktage' : '')
      : (i.lz ? 'Lieferzeit ca. ' + esc(i.lz) + ' Werktage' : '');
    var sheet = GE.sheetSvg(i.f, i.s, i.n, i.m, { pattern: true, id: 'c' + idx, b: i.b, decorative: true });
    return '<li class="ge-card">' +
      '<a class="ge-card__link" href="' + GE.productUrl(i.h) + '">' +
        '<span class="ge-card__sheet">' + sheet + '</span>' +
        '<span class="ge-card__body">' +
          '<span class="ge-card__mat"><span class="ge-mat__sw ge-mat__sw--' + i.m + '" aria-hidden="true"></span>' + esc(GE.MAT[i.m] || '') + ', ' + esc(GE.FORM[i.f] || i.f) + '</span>' +
          '<span class="ge-card__title">' + esc(GE.sizeLabel(i.s)) + '</span>' +
          '<span class="ge-card__meta">' + i.n + ' pro Bogen, ' + (i.b ? 'Bogen ' + esc(GE.sizeLabel(i.b)) : 'DIN A4') + '</span>' +
          (lz ? '<span class="ge-card__meta">' + lz + '</span>' : '') +
          fitTxt +
          '<span class="ge-card__price"><span>' + esc(i.u || 'ab') + '</span><strong>' + GE.money(i.pu) + '</strong></span>' +
          (i.p10 && i.u !== '10 Blatt' ? '<span class="ge-card__small">Kleinpackung 10 Blatt: ' + GE.money(i.p10) + '</span>' : '') +
        '</span>' +
      '</a></li>';
  };

  Finder.prototype.render = function (writeUrl) {
    var self = this, st = this.state();
    this.el.classList.toggle('is-round', st.form === 'rund');
    if (this.form.elements.w) this.form.elements.w.placeholder = st.form === 'rund' ? 'z. B. 40' : 'z. B. 70';
    if (writeUrl) this.toUrl(st);
    this.counts(st);

    var res = this.items.filter(function (i) { return self.pass(i, st); }).sort(this.sorter(st));
    var near = false;
    if (!res.length && st.w) {
      near = true;
      var s2 = { form: st.form, w: st.w, h: st.h, tol: Infinity, m: st.m, lager: st.lager, k10: st.k10, abl: st.abl, sort: 'fit' };
      res = this.items.filter(function (i) { return self.pass(i, st, null, true); }).sort(this.sorter(s2)).slice(0, 8);
    }
    var total = res.length;
    var show = res.slice(0, this.shown);
    this.list.innerHTML = show.map(function (i, k) { return self.card(i, k, st, near); }).join('');

    var txt;
    if (near && total) txt = 'Kein Format innerhalb ± ' + fmtNum(st.tol) + ' mm. Die nächstgelegenen Formate:';
    else if (!total) txt = 'Keine passenden Formate gefunden. Lockern Sie die Filter oder setzen Sie sie zurück.';
    else txt = total === 1 ? '1 Format gefunden' : total + ' Formate gefunden';
    if (this.countEl) this.countEl.textContent = txt;
    this.el.classList.toggle('is-empty', !total);

    if (this.moreBtn) {
      var rest = near ? 0 : total - show.length;
      this.moreBtn.hidden = rest <= 0;
      this.moreBtn.textContent = 'Weitere Formate anzeigen (' + rest + ')';
    }
    if (this.ehLink) {
      var qy = '';
      if (st.w && st.h) qy = fmtNum(st.w) + 'x' + fmtNum(st.h);
      else if (st.w) qy = fmtNum(st.w) + ' mm' + (st.form === 'rund' ? ' rund' : '');
      this.ehLink.href = qy ? this.ehBase + encodeURIComponent(qy) : this.ehLink.getAttribute('data-ge-eh-home');
    }
  };

  Finder.prototype.bind = function () {
    var self = this, f = this.form;
    f.addEventListener('submit', function (e) { e.preventDefault(); self.shown = PAGE; self.render(true); });
    f.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'w' || e.target.name === 'h')) return;
      self.shown = PAGE;
      self.render(true);
    });
    f.addEventListener('input', function (e) {
      if (!e.target || (e.target.name !== 'w' && e.target.name !== 'h')) return;
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.shown = PAGE; self.render(true); }, 300);
    });
    f.addEventListener('reset', function () {
      setTimeout(function () {
        each(f.querySelectorAll('input'), function (i) { i.disabled = false; });
        self.shown = PAGE;
        self.render(true);
      }, 0);
    });
    if (this.moreBtn) {
      this.moreBtn.addEventListener('click', function () {
        var first = self.list.children.length;
        self.shown += PAGE;
        self.render(false);
        var next = self.list.children[first];
        var a = next && next.querySelector('a');
        if (a) a.focus({ preventScroll: true });
      });
    }
  };

  /* ---------- Kennzahlen (Anzahl Formate, Preis ab) ---------- */
  function fillStats(nodes, items, GE) {
    each(nodes, function (el) {
      var kind = el.getAttribute('data-ge-stat'), m = el.getAttribute('data-m') || '';
      var set = items.filter(function (i) { return !m || i.m === m; });
      var out = '';
      if (kind === 'count') {
        out = set.length ? String(set.length) : '';
      } else if (kind === 'forms') {
        var fs = {};
        set.forEach(function (i) { fs[i.f] = 1; });
        out = String(Object.keys(fs).length);
      } else if (kind === 'price') {
        var min = 0;
        set.forEach(function (i) { if (!i.so && i.u === '50 Blatt' && i.pu && (!min || i.pu < min)) min = i.pu; });
        out = min ? GE.money(min) : '';
      }
      if (!out) return;
      el.textContent = out;
      var wrap = el.closest('[data-ge-stat-wrap]');
      if (wrap) wrap.hidden = false;
    });
  }

  ready(function () {
    var GE = window.GE;
    if (!GE) return;
    each(document.querySelectorAll('[data-ge-icon]'), function (el) {
      if (!el.firstChild) el.innerHTML = GE.iconSvg(el.getAttribute('data-ge-icon'));
    });
    var finders = document.querySelectorAll('[data-ge-finder]');
    var stats = document.querySelectorAll('[data-ge-stat]');
    if (!finders.length && !stats.length) return;
    GE.loadIndex().then(function (items) {
      each(finders, function (el) { if (!el.__ge) el.__ge = new Finder(el, items, GE); });
      fillStats(stats, items, GE);
    }).catch(function () {
      each(finders, function (el) {
        var c = el.querySelector('[data-ge-count]');
        if (c) c.textContent = 'Die Formate konnten gerade nicht geladen werden. Bitte laden Sie die Seite neu.';
        el.classList.add('is-error');
      });
    });
  });
})();